import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import {
    isEmpty,
    find,
    size,
    debounce,
    parseInt,
    omit,
} from "lodash";
import defaultValues from "../../constant/defaultValues";
import errorMessages from "../../constant/errorMessages";
import regExp from "../../constant/regExpressions";
import {
    showSuccessMessage,
    showErrorMessage,
} from "../../utils/common";

import { getMemberList } from "../../actions/memberAction";
import { roleList } from "../../actions/rolesAction";

import AcSimpleTable from "../../components/AcSimpleTable";
import InputField from "../../components/InputField";
import MediumPopup from "../../components/MediumPopup";
import SmallPopup from "../../components/SmallPopup";
import SubHeader from "../../components/SubHeader";
import ButtonAdd from "../../components/ButtonAdd";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { createPlan, deletePlan, getPlan, getSubscriptionPlanList, updatePlan, checkPriority, checkSubscriptionName } from "../../actions/subscriptionPlanAction";
import ToolipsCustom from "../../components/ToolipsCustom";
import DropDown from "../../components/DropDown";
import CheckBox from "../../components/CheckBox";
import { useAuth } from "@/AuthProvider";

function SubscriptionPlans(props) {
    const { admin } = defaultValues;

    const {isAdmin} = useAuth();

    const [tableKey, setTableKey] = useState(0);
    const [planList, setPlanList] = useState([]);
    const [offset, setOffset] = useState(admin.OFFSET);
    const [limit, setLimit] = useState(admin.LIMIT);
    const [searchTxt, setSearchTxt] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalRows, settotalRows] = useState(0);

    const [mediummodalShow, setMediumModalShow] = useState(false);
    const [smallmodalShow, setSmallModalShow] = useState(false);

    const [formdata, setFormData] = useState({
        name: "",
        type: null,
        // price: 0,
        status: 1,
        priority: null,
        download_credit: null,
        top_search_credit: null,
        view_credit: null,
        logistic_credit: 0,
        supplier_credit: 0,
        is_landing_page: false,
        allowed_products: 0,
        plan_price: 0,
        plan_discount: null
        // valid_plan:null
    });

    const [deletePlanId, setDeletePlanId] = useState();
    const [editedplanId, setEditedPlanId] = useState(0);
    const [columnName, setColumnName] = useState(admin.COLUMN_NAME);
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
    const [current_page, setCurrentPage] = useState(1);
    const [nodata, setNoData] = useState(false);
    const [isButtonDisabled, setisButtonDisabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [selectedType, setSelectedType] = useState();

    // const [selectedValidPlan, setSelectedValidPlan] = useState();

    const initialRef = useRef(true);

    const planTypeOption = [
        { label: "Buyer", value: "BUYER" },
        { label: "Supplier", value: "SUPPLIER" },
        { label: "Logistic Partner", value: "LOG_PTR" },
    ];

    const columns = [
        {
            name: 'Sr No',
            selector: (row, idx) => {
                return (
                    <>{offset + (idx + 1)}</>
                )
            },
            resizable: true,
            maxWidth: "8%"
        },
        {
            name: "Plan Name",
            selector: (row) => <div className="tbl-text-wrap-row">{row.name}</div>, // white-space: pre;
            resizable: true,
            columnName: "name",
            sortable: true,
            maxWidth: "25%",
        },
        {
            name: "Plan Type",
            selector: (row) => <div className="tbl-text-wrap-row">{row.type}</div>, // white-space: pre;
            resizable: true,
            columnName: "type",
            sortable: true,
            maxWidth: "9%",
        },
        {
            name: "Priority",
            selector: (row) => <div className="tbl-text-wrap-row">{row.priority}</div>, // white-space: pre;
            resizable: true,
            columnName: "priority",
            sortable: false,
            maxWidth: "6%",
        },
        {
            name: "Price",
            selector: (row) => <div className="tbl-text-wrap-row">{row.price}</div>, // white-space: pre;
            resizable: true,
            columnName: "download_credit",
            sortable: false,
            maxWidth: "8%",
        },
        {
            name: "Discount",
            selector: (row) => <div className="tbl-text-wrap-row">{(row.discount) ? row.discount : '-'}</div>, // white-space: pre;
            resizable: true,
            columnName: "top_search_credit",
            sortable: false,
            maxWidth: "10%",
        },
        {
            name: "View Credit",
            selector: (row) => <div className="tbl-text-wrap-row">{row.view_credit}</div>, // white-space: pre;
            resizable: true,
            columnName: "view_credit",
            sortable: false,
            maxWidth: "10%",
        },
        {
            name: "Supplier Credit",
            selector: (row) => <div className="tbl-text-wrap-row">{row.supplier_credit}</div>, // white-space: pre;
            resizable: true,
            columnName: "view_credit",
            sortable: false,
            maxWidth: "10.5%",
        },
        {
            name: "Logistic Credit",
            selector: (row) => <div className="tbl-text-wrap-row">{row.logistic_credit}</div>, // white-space: pre;
            resizable: true,
            columnName: "view_credit",
            sortable: false,
            maxWidth: "10.5%",
        },
        {
            name: "Allowed Products",
            selector: (row) => <div className="tbl-text-wrap-row">{row.allowed_products}</div>, // white-space: pre;
            resizable: true,
            columnName: "allowed_products",
            sortable: false,
            maxWidth: "10%",
        },
        {
            name: "Landing Page",
            selector: (row) => <div className="tbl-text-wrap-row">{row.is_landing_page == 1 ? 'YES' : ' - '}</div>, // white-space: pre;
            resizable: true,
            columnName: "is_landing_page",
            sortable: true,
            maxWidth: "11%",
        },
        // {
        //     name: "Valid Plan",
        //     selector: (row) => <div className="tbl-text-wrap-row">{row.valid_plan > 0 ?  row.valid_plan + ' Month' : ''}</div>, // white-space: pre;
        //     resizable: true,
        //     columnName: "valid_plan",
        //     sortable: true,
        //     maxWidth: "10%",
        // },
        /*{
            name: "Status",
            selector: (row) => {
                const rowStatus = statusOptions.find(option => option.value === row.status);
                return rowStatus.label;
            },
            resizable: true,
            maxWidth: "150px"
        }, */
        {
            omit: isAdmin,
            name: "Actions",
            cell: (row) => (
                <>
                    {

                        <>


                            {/* <button className="btn" onClick={() => handleEditClick(row.id)} data-toggle="tooltip" data-placement="top" title="Edit">
                                <i className="fa-regular fa-pen-to-square icon-pen"></i>
                            </button> */}

                            <ToolipsCustom
                                subtitle="Edit"
                                className="fa-regular fa-pen-to-square icon-pen border-0 "
                                classNameChild={"data-table-tooltiop"}
                                onClick={() => handleEditClick(row.id)}
                            ></ToolipsCustom>



                            {/* <button className="btn" onClick={() => handleDeleteClick(row.id)} data-toggle="tooltip" data-placement="top" title="Delete">
                                <i className="fa-solid fa-trash-can icon-trash" aria-hidden="true"></i>
                            </button> */}

                            <ToolipsCustom
                                subtitle="Delete"
                                className="fa-solid fa-trash-can icon-trash border-0 "
                                classNameChild={"data-table-tooltiop"}
                                onClick={() => handleDeleteClick(row.id)}
                            ></ToolipsCustom>
                        </>

                    }
                </>
            ),
            resizable: true,
            ignoreRowClick: true,
            allowoverflow: true,
            button: true,
            maxWidth: "7%"
            // minWidth: "200px"
        },

    ];

    const handleSort = async (column, sortDirection) => {
        setColumnName(column.columnName);
        setSortDirection(sortDirection);
        // getSubscriptionsPlansData(
        //     admin.OFFSET,
        //     admin.LIMIT,
        //     current_page,
        //     column.columnName,
        //     sortDirection,
        //     searchTxt
        // );

        getSubscriptionsPlansData(
            offset,
            limit,
            current_page,
            column.columnName,
            sortDirection,
            searchTxt
        );
    };

    const handleAddUserClick = () => {
        setFormData({
            name: "",
            // price: 0,
            status: 1,
            priority: null,
            download_credit: null,
            top_search_credit: null,
            view_credit: null,
            type: null,
            is_landing_page: false,
            allowed_products: 0,
            plan_price: 0,
            plan_discount: null
            // valid_plan:null
        });
        setErrors({});
        setEditedPlanId(0);
        setMediumModalShow(true);
        setisButtonDisabled(false);
        setSelectedType();
        // setSelectedValidPlan();
    };

    const handleEditClick = async (id) => {
        setErrors({});
        await props.showLoading();
        await props
            .getPlan(id)
            .then(async (response) => {
                setFormData({
                    name: response.data[0].name,
                    priority: response.data[0].priority,
                    download_credit: response.data[0].download_credit,
                    top_search_credit: response.data[0].top_search_credit,
                    view_credit: response.data[0].view_credit,
                    supplier_credit: response.data[0].supplier_credit,
                    logistic_credit: response.data[0].logistic_credit,
                    // price: 0,
                    type: response.data[0].type,
                    is_landing_page: response.data[0].is_landing_page,
                    allowed_products: response.data[0].allowed_products,
                    plan_price: response.data[0].price,
                    plan_discount: response.data[0].discount
                    // valid_plan: response.data[0].valid_plan
                });
                setMediumModalShow(true);
                setEditedPlanId(id);
                setisButtonDisabled(false);
                const typeOpt = find(planTypeOption, option => option.value === response.data[0].type);
                setSelectedType(typeOpt);
                // const validOpt = find(planValideOption, option => option.value === response.data[0].valid_plan);
                // setSelectedValidPlan(validOpt);
            })
            .catch((err) => {
                console.log("Error ===== ", err);
                showErrorMessage("Something Went Wrong!!");
            });
        await props.hideLoading();
    };

    const handleDeleteClick = (id) => {
        setSmallModalShow(true);
        setDeletePlanId(id);
    };

    const handleConfirmDeleteClick = () => {
        props
            .deletePlan(deletePlanId)
            .then((response) => {
                if (response.status === true) {
                    showSuccessMessage("Plan Deleted Successfully");
                    setOffset(admin.OFFSET);
                    setLimit(admin.LIMIT);
                    setColumnName(admin.COLUMN_NAME);
                    setSortDirection(admin.SORT_DIRECTION);
                    setSearchTxt("");
                    getSubscriptionsPlansData(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, "");
                } else {
                    showErrorMessage(response.message);
                }
                setSmallModalShow(false);
            })
            .catch((err) => {
                console.log("Error == ", err);
                showErrorMessage("Something Went Wrong!!");
            });
    };

    const handleChange = (e) => {
        setFormData((prevalue) => {
            return {
                ...prevalue,
                [e.target.name]: e.target.value,
            };
        });
    };

    const handleFocusOut = async (e) => {
        let flag = 0;
        let errObj = { ...errors };
        if (e.target.name === "name") {
            if (isEmpty(e.target.value)) {
                flag = 1;
                errObj.name = errorMessages.FIELD_REQUIRED;
            } else if (size(e.target.value) > 40) {
                flag = 1;
                errObj.name = 'The field must not be greater than 40 characters.';
            } else if (!isEmpty(e.target.value)) {
                const nameregExp = regExp.name;
                const check = nameregExp.test(e.target.value);
                if (check === false) {
                    flag = 1;
                    errObj.name = errorMessages.IN_VALID_FIELD_FORMAT;
                } else {
                    flag = 0;
                    errObj.name = "";
                    const response = await props.checkSubscriptionName(editedplanId, e.target.value, formdata.type);
                    if (response.status === true) {
                        flag = 1;
                        errObj.name = response.message;
                    } else {
                        flag = 0;
                        errObj.name = "";
                    }

                }
            }
        }

        if (e.target.name === "priority") {
            if (isEmpty(e.target.value)) {
                flag = 1;
                errObj.priority = errorMessages.FIELD_REQUIRED;

            } else {
                flag = 0;
                errObj.priority = '';
            }

            if (!isEmpty(e.target.value)) {
                const nameregExp = regExp.natural_number;
                const check = nameregExp.test(e.target.value);
                if (check === false) {
                    flag = 1;
                    errObj.priority = errorMessages.IN_VALID_FIELD_FORMAT;
                }
                const response = await props.checkPriority(editedplanId, e.target.value, formdata.type);
                if (response.status === true) {
                    flag = 1;
                    errObj.priority = response.message;
                } else {
                    if (size(e.target.value) > 40) {
                        flag = 1;
                        errObj.priority = 'The field must not be greater than 40 characters.';
                    } else {
                        flag = 0;
                        errObj.priority = '';
                    }
                }

            }


        }

        if (e.target.name === "download_credit") {
            const value = e.target.value;

            if (isEmpty(value)) {
                flag = 1;
                errObj.download_credit = errorMessages.FIELD_REQUIRED;
            } else if (size(value) > 40) {
                flag = 1;
                errObj.download_credit = 'The field must not be greater than 40 characters.';
            } else {
                const nameregExp = regExp.natural_number;
                const isValid = nameregExp.test(value);

                if (!isValid) {
                    flag = 1;
                    errObj.download_credit = errorMessages.IN_VALID_FIELD_FORMAT;
                } else {
                    flag = 0;
                    errObj.download_credit = "";
                }
            }
        }


        if (e.target.name === "top_search_credit") {
            const value = e.target.value;
            if (isEmpty(value)) {
                flag = 1;
                errObj.top_search_credit = errorMessages.FIELD_REQUIRED;
            } else if (size(value) > 40) {
                flag = 1;
                errObj.top_search_credit = 'The field must not be greater than 40 characters.';
            } else {
                const nameregExp = regExp.natural_number;;
                const check = nameregExp.test(value);
                if (check === false) {
                    flag = 1;
                    errObj.top_search_credit = errorMessages.IN_VALID_FIELD_FORMAT;
                } else {
                    flag = 0;
                    errObj.top_search_credit = "";
                }
            }

        }


        if (e.target.name === "view_credit") {
            const value = e.target.value;
            if (isEmpty(value)) {
                flag = 1;
                errObj.view_credit = errorMessages.FIELD_REQUIRED;
            } else if (size(value) > 40) {
                flag = 1;
                errObj.view_credit = 'The field must not be greater than 40 characters.';
            } else {
                const nameregExp = regExp.natural_number;;
                const check = nameregExp.test(value);
                if (check === false) {
                    flag = 1;
                    errObj.view_credit = errorMessages.IN_VALID_FIELD_FORMAT;
                } else {
                    errObj.view_credit = "";
                    flag = 0;
                }
            }

        }

        if(e.target.name === "supplier_credit") {
            const value = e.target.value;
            if (isEmpty(value)) {
                flag = 1;
                errObj.supplier_credit = errorMessages.FIELD_REQUIRED;
            } else if (size(value) > 40) {
                flag = 1;
                errObj.supplier_credit = 'The field must not be greater than 40 characters.';
            } else {
                const nameregExp = regExp.natural_number;;
                const check = nameregExp.test(value);
                if (check === false) {
                    flag = 1;
                    errObj.supplier_credit = errorMessages.IN_VALID_FIELD_FORMAT;
                } else if(parseInt(formdata.view_credit) > 0 && ( parseInt(value) > parseInt(formdata.view_credit))) {
                    flag = 1;
                    errObj.supplier_credit = errorMessages.CREDIT_EXCEED;
                } else {
                    errObj.supplier_credit = "";
                    flag = 0;
                }
            }
        }

        if(e.target.name === "logistic_credit") {
            const value = e.target.value;
            console.log("value ================ ", typeof value, " ================ ", typeof formdata.view_credit)
            if (isEmpty(value)) {
                flag = 1;
                errObj.logistic_credit = errorMessages.FIELD_REQUIRED;
            } else if (size(value) > 40) {
                flag = 1;
                errObj.logistic_credit = 'The field must not be greater than 40 characters.';
            } else {
                const nameregExp = regExp.natural_number;;
                const check = nameregExp.test(value);
                if (check === false) {
                    flag = 1;
                    errObj.logistic_credit = errorMessages.IN_VALID_FIELD_FORMAT;
                } else if(parseInt(formdata.view_credit) > 0 && (parseInt(value) > parseInt(formdata.view_credit))) {
                    flag = 1;
                    errObj.logistic_credit = errorMessages.CREDIT_EXCEED;
                } else {
                    errObj.logistic_credit = "";
                    flag = 0;
                }
            }
        }


        setErrors(errObj);
        if (flag === 0) {
            setisButtonDisabled(false);
            return false;
        } else {
            setisButtonDisabled(true);
            return true;
        }

    };

    const handleFocusOut0 = () => {

        if (selectedType === undefined || selectedType === null || isEmpty(selectedType)) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [`type`]: errorMessages.FIELD_REQUIRED,
            }));
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [`type`]: "",
            }));
        }
    }


    const validForm = async () => {

        let hasError = false;
        let errObj = { ...errors };

        if (isEmpty(formdata.name)) {
            hasError = true;
            errObj.name = errorMessages.FIELD_REQUIRED;
        } else if (size(formdata.name) > 40) {
            hasError = true;
            errObj.name = 'The field must not be greater than 40 characters.';
        } else if (!regExp.name.test(formdata.name)) {
            hasError = true;
            errObj.name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
            errObj.name = "";
            const response = await props.checkSubscriptionName(editedplanId, formdata.name, formdata.type);
            if (response.status === true) {
                hasError = true;
                errObj.name = response.message;
            } else {
                errObj.name = "";
            }

        }

        if (isEmpty(formdata.type)) {
            hasError = true;
            errObj.type = errorMessages.FIELD_REQUIRED;
        } else {
            errObj.type = "";
        }

        // if (isEmpty(formdata.valid_plan) || formdata.valid_plan === null || formdata.valid_plan === undefined) {
        //     hasError = true;
        //     errObj.valid_plan = errorMessages.FIELD_REQUIRED;
        // } else {
        //     errObj.valid_plan = "";
        // }

        if (editedplanId > 0) {

            if (isEmpty(formdata.priority)) {
                hasError = true;
                errObj.priority = errorMessages.FIELD_REQUIRED;
            } else if (size(formdata.priority) > 40) {
                hasError = true;
                errObj.priority = 'The field must not be greater than 40 characters.';
            } else if (!regExp.natural_number.test(formdata.priority)) {
                hasError = true;
                errObj.priority = errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
                const response = await props.checkPriority(editedplanId, formdata.priority, formdata.type);
                if (response.status === true) {
                    hasError = true;
                    errObj.priority = response.message;
                } else {
                    errObj.priority = "";
                }
            }
        }

        const creditFields = ['download_credit', 'top_search_credit', 'view_credit','logistic_credit','supplier_credit'];
        creditFields.forEach(field => {
            const value = formdata[field];

            if (isEmpty(value)) {
                hasError = true;
                errObj[field] = errorMessages.FIELD_REQUIRED;
            } else if (size(value) > 40) {
                hasError = true;
                errObj[field] = 'The field must not be greater than 40 characters.';
            } else if (!regExp.natural_number.test(value)) {
                hasError = true;
                errObj[field] = errorMessages.IN_VALID_FIELD_FORMAT;
            } else if(field == "logistic_credit" || field == "supplier_credit") {
                if(parseInt(formdata.view_credit) > 0 && (parseInt(value) > parseInt(formdata.view_credit))) {
                    hasError = true;
                    errObj[field] = errorMessages.CREDIT_EXCEED;
                } else if(parseInt(formdata.view_credit) > 0 && (parseInt(formdata.view_credit) != (parseInt(formdata.supplier_credit) + parseInt(formdata.logistic_credit)))) {
                    hasError = true;
                    errObj['view_credit'] = errorMessages.CREDIT_TOTAL_NOT_MATCH;
                }
            }else {
                errObj[field] = ""; // Valid field
            }
        });

        setErrors(errObj);
        return !hasError;
    };

    const handleEnableLandingChange = () => {
        setFormData((preValue) => {
            return {
                ...preValue,
                is_landing_page: !formdata.is_landing_page
            }

        });
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('formData', formdata);
        const isValid = await validForm();
        if (isValid) {
            props.showLoading();
            if (editedplanId > 0) {
                // console.log("Edit plan clicked.");
                await props
                    .updatePlan(editedplanId, formdata)
                    .then((response) => {
                        // console.log("Response123456 ========== ", response);
                        if (response.status === true) {
                            setMediumModalShow(false);
                            setOffset(admin.OFFSET);
                            setLimit(admin.LIMIT);
                            setColumnName(admin.COLUMN_NAME);
                            setSortDirection(admin.SORT_DIRECTION);
                            setSearchTxt("");
                            getSubscriptionsPlansData(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, "");
                            showSuccessMessage(response.message);
                        } else if (response.status === false) {
                            let errObj = {};
                            if (response.error) {
                                if (response.error.name) {
                                    errObj.name = response.error.name[0];
                                }
                                if (response.error.priority) {
                                    errObj.priority = response.error.priority[0];
                                }
                                if (response.error.download_credit) {
                                    errObj.download_credit = response.error.download_credit[0];
                                }
                                if (response.error.top_search_credit) {
                                    errObj.top_search_credit = response.error.top_search_credit[0];
                                }
                                if (response.error.view_credit) {
                                    errObj.view_credit = response.error.view_credit[0];
                                }
                                if (response.error.type) {
                                    errObj.type = response.error.type[0];
                                }
                                if (response.error.type) {
                                    errObj.type = response.error.valid_plan[0];
                                }

                                if (response.error.plan_price) {
                                    errObj.plan_price = response.error.plan_price[0];
                                }
                            }
                            setErrors(errObj);
                        }
                    })
                    .catch((err) => {
                        console.log("Error ======= ", err);
                        showErrorMessage("something went wrong!");
                    });
            } else {
                // console.log("Add clicked...");
                await props
                    .savePlan(formdata)
                    .then((response) => {
                        // console.log("Response ==== ", response);
                        if (response.status === true) {
                            setMediumModalShow(false);
                            setOffset(admin.OFFSET);
                            setLimit(admin.LIMIT);
                            setColumnName(admin.COLUMN_NAME);
                            setSortDirection(admin.SORT_DIRECTION);
                            setSearchTxt("");
                            getSubscriptionsPlansData(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, "");
                            showSuccessMessage(response.message);
                        } else if (response.status === false) {
                            let errObj = {};
                            // console.log("Error =========== ", response.error);
                            if (response.error) {

                                if (response.error.name) {
                                    errObj.name = response.error.name[0];
                                }

                                if (response.error.download_credit) {
                                    errObj.download_credit = response.error.download_credit[0];
                                }
                                if (response.error.top_search_credit) {
                                    errObj.top_search_credit = response.error.top_search_credit[0];
                                }
                                if (response.error.view_credit) {
                                    errObj.view_credit = response.error.view_credit[0];
                                }
                                if (response.error.type) {
                                    errObj.type = response.error.type[0];
                                }
                                if (response.error.plan_price) {
                                    errObj.plan_price = response.error.plan_price[0];
                                }
                                
                                

                            }

                            setErrors(errObj);
                        }
                    })
                    .catch((err) => {
                        console.log("Error ====== ", err);
                        showErrorMessage("Something Went Wrong!!");
                    });
            }
            props.hideLoading();
        }
    };

    const onSearchTextBoxChanged = debounce((e) => {
        setSearchTxt(e.target.value);
        let searchVal = e.target.value;
        if (searchVal.length >= 3 || searchVal.length <= 0) {
            setOffset(admin.OFFSET);
            setLimit(admin.LIMIT);
            setColumnName(admin.COLUMN_NAME);
            setSortDirection(admin.SORT_DIRECTION);
            setTableKey((prev) => prev + 1);
            getSubscriptionsPlansData(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, e.target.value);
        }
    });



    const getSubscriptionsPlansData = async (offset, limit, current_page, columnName, sortDirection, searchTxt) => {
        setNoData(false);
        await props.showLoading();
        await props
            .getSubscriptionPlans(offset, limit, columnName, sortDirection, null, searchTxt)
            .then((response) => {
                setPlanList([]);
                if (size(response.data) === 0) {
                    setNoData(true);
                }
                setPlanList(response.data);
                settotalRows(response.metadata.total);
            })
            .catch((err) => {
                console.log("Error ==== ", err);
                showErrorMessage("Something Went Wrong!!");
            });
        await props.hideLoading();
    };

    const handleTypeChange = (event) => {
        setErrors((prev) => {
            return {
                ...prev,
                type: "",
            };
        });
        setFormData((prevalue) => {
            return {
                ...prevalue,
                type: event.value
            };
        });
        setSelectedType(event);
    }

    useEffect(() => {
        if (initialRef.current === true) {
            initialRef.current = false;
            getSubscriptionsPlansData(offset, limit, current_page, columnName, sortDirection, searchTxt);
        }

    }, []);


    // const handleValidPlanChange = (event) => {
    //     setErrors((prev) => {
    //         return {
    //             ...prev,
    //             valid_plan: "",
    //         };
    //     });
    //     setFormData((prevalue) => {
    //         return {
    //             ...prevalue,
    //             valid_plan: event.value
    //         };
    //     });
    //     setSelectedValidPlan(event);
    // }
    console.log("selectedType >>>>>>>>>>> ", selectedType)
    return (
        <>
            <div className='data-table-main'>

                <div className="AcSimpleTable">

                    <SubHeader layer1="Subscription Management" layer2="Plans" layer3="List" pageName="Plans" subTitle="" clickable={{
                        layer1: "",
                        layer2: "",
                        layer3: ""
                    }} />

                    <div className="AcSimpleTable">

                        {/** Add/Edit Subscription plan popup */}
                        <MediumPopup
                            title={editedplanId > 0 ? "Edit Plan" : "Create Plan"}
                            mediummodalShow={mediummodalShow}
                            setMediumModalShow={setMediumModalShow}
                            onSubmit={handleSubmit}
                            okButtonLabel={editedplanId > 0 ? "Update" : "Create"}
                            closeButtonLabel="Cancel"
                            disabled={isButtonDisabled}
                        >
                            <form onSubmit={handleSubmit}>
                                {/* <div className="row justify-content-cetner align-items-center"> */}
                                <div className='row my-3'>

                                    <div className="col-xl-6 mt-1">
                                        <label className='popup-input-lable field-required'>Type</label>
                                        <DropDown
                                            options={planTypeOption}
                                            placehoder="Select Type"
                                            onChange={handleTypeChange}
                                            name="type"
                                            value={selectedType}
                                            noOptionsMessage={() => "No Type Found"}
                                            onFocus={handleFocusOut0}
                                        ></DropDown>
                                        {errors.type && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.type}
                                            </p>
                                        )}
                                    </div>

                                    <div className='col-xl-6 mt-1'>
                                        <label className='popup-input-lable field-required'>Name</label>
                                        <InputField
                                            className=""
                                            placeholder={"Enter plan name"}
                                            name="name"
                                            onChange={handleChange}
                                            value={formdata.name}
                                            onBlur={handleFocusOut}
                                            maxLength={255 + 1}
                                            autoComplete="off"
                                        ></InputField>
                                        {errors.name && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.name}
                                            </p>
                                        )}
                                    </div>

                                    {editedplanId > 0 && (
                                        <div className='col-xl-6 mt-1'>
                                            <label className='popup-input-lable field-required'>Priority</label>
                                            <InputField
                                                className=""
                                                placeholder={"Enter priority"}
                                                name="priority"
                                                onChange={handleChange}
                                                value={formdata.priority}
                                                onBlur={handleFocusOut}
                                                maxLength={255 + 1}
                                                autoComplete="off"
                                            ></InputField>

                                            <div>
                                                <p><small><em><b>Note :</b> Higher priority places company higher in list.</em></small></p>
                                            </div>


                                            {errors.priority && (
                                                <p
                                                    className="invalid-feedback"
                                                    style={{ display: "block" }}
                                                >
                                                    {errors.priority}
                                                </p>
                                            )}
                                        </div>
                                    )}

                                    <div className='col-xl-6 mt-1'>
                                        <label className='popup-input-lable field-required'>Download Credit</label>
                                        <InputField
                                            className=""
                                            placeholder={"Enter download credit"}
                                            name="download_credit"
                                            onChange={handleChange}
                                            value={formdata.download_credit}
                                            onBlur={handleFocusOut}
                                            maxLength={255 + 1}
                                            autoComplete="off"
                                        ></InputField>
                                        {errors.download_credit && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.download_credit}
                                            </p>
                                        )}
                                    </div>

                                    <div className='col-xl-6 mt-1'>
                                        <label className='popup-input-lable field-required'>Top Search Credit</label>
                                        <InputField
                                            className=""
                                            placeholder={"Enter top search credit"}
                                            name="top_search_credit"
                                            onChange={handleChange}
                                            value={formdata.top_search_credit}
                                            onBlur={handleFocusOut}
                                            maxLength={255 + 1}
                                            autoComplete="off"
                                        ></InputField>
                                        {errors.top_search_credit && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.top_search_credit}
                                            </p>
                                        )}
                                    </div>

                                    <div className='col-xl-6 mt-1'>
                                        <label className='popup-input-lable field-required'>View Credit</label>
                                        <InputField
                                            className=""
                                            placeholder={"Enter view credit"}
                                            name="view_credit"
                                            onChange={handleChange}
                                            value={formdata.view_credit}
                                            onBlur={handleFocusOut}
                                            maxLength={255 + 1}
                                            autoComplete="off"
                                        ></InputField>
                                        {errors.view_credit && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.view_credit}
                                            </p>
                                        )}
                                    </div>

                                    <div className='col-xl-6 mt-1'>
                                        <label className='popup-input-lable field-required'>Logistics Credits</label>
                                        <InputField
                                            className=""
                                            placeholder={"Enter logistics credit"}
                                            name="logistic_credit"
                                            onChange={handleChange}
                                            value={formdata.logistic_credit}
                                            onBlur={handleFocusOut}
                                            maxLength={255 + 1}
                                            autoComplete="off"
                                        ></InputField>
                                        {errors.logistic_credit && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.logistic_credit}
                                            </p>
                                        )}
                                    </div>

                                    <div className='col-xl-6 mt-1'>
                                        <label className='popup-input-lable field-required'>Supplier Credits</label>
                                        <InputField
                                            className=""
                                            placeholder={"Enter supplier credit"}
                                            name="supplier_credit"
                                            onChange={handleChange}
                                            value={formdata.supplier_credit}
                                            onBlur={handleFocusOut}
                                            maxLength={255 + 1}
                                            autoComplete="off"
                                        ></InputField>
                                        {errors.supplier_credit && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.supplier_credit}
                                            </p>
                                        )}
                                    </div>

                                    <div className='col-xl-6 mt-1'>
                                        <label className={`popup-input-lable ${selectedType?.value === "SUPPLIER" ? "field-required" : ""}`}>Allowed Products</label>
                                        <InputField
                                            className=""
                                            placeholder={"Enter view credit"}
                                            name="allowed_products"
                                            onChange={handleChange}
                                            value={selectedType && selectedType.value === "SUPPLIER" ? formdata.allowed_products : 0}
                                            onBlur={handleFocusOut}
                                            maxLength={255 + 1}
                                            autoComplete="off"
                                            disabled={selectedType && selectedType.value === "SUPPLIER" ? false : true}
                                        ></InputField>
                                        {errors.view_credit && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.allowed_products}
                                            </p>
                                        )}
                                    </div>

                                    <div className='col-xl-6 mt-1'>
                                        <label className={`popup-input-lable ${selectedType?.value === "SUPPLIER" ? "field-required" : ""}`}>Price</label>
                                        <InputField
                                            className=""
                                            placeholder={"Enter price"}
                                            name="plan_price"
                                            onChange={handleChange}
                                            value={selectedType && selectedType.value === "SUPPLIER" ? formdata.plan_price : 0}
                                            onBlur={handleFocusOut}
                                            maxLength={255 + 1}
                                            autoComplete="off"
                                            disabled={selectedType && selectedType.value === "SUPPLIER" ? false : true}
                                        ></InputField>
                                        {errors.plan_price && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.plan_price}
                                            </p>
                                        )}
                                    </div>

                                    <div className='col-xl-6 mt-1'>
                                        <label className={`popup-input-lable ${selectedType?.value === "SUPPLIER" ? "field-required" : ""}`}>Discount (in %)</label>
                                               
                                       <InputField
                                            className=""
                                            placeholder={"Enter discount"}
                                            name="plan_discount"
                                            onChange={handleChange}
                                            value={selectedType && selectedType.value === "SUPPLIER" ? formdata.plan_discount : 0}
                                            onBlur={handleFocusOut}
                                            maxLength={255 + 1}
                                            autoComplete="off"
                                            disabled={selectedType && selectedType.value === "SUPPLIER" ? false : true}
                                        ></InputField>
                                        {errors.plan_discount && (
                                            <p
                                                className="invalid-feedback"
                                                style={{ display: "block" }}
                                            >
                                                {errors.plan_discount}
                                            </p>
                                        )}
                                    </div>

                                    <div className='col-xl-6 mt-1'>
                                        <div className={editedplanId > 0 ? "mt-3 d-flex align-items-center" : "mt-4 d-flex align-items-center"}>
                                            <CheckBox
                                                value={formdata.is_landing_page}
                                                onChange={() => handleEnableLandingChange()}
                                                checked={formdata.is_landing_page}
                                            ></CheckBox>
                                            <label className="popup-input-lable ms-2 mb-0">Enable Landing Page</label>
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </MediumPopup>

                        {/** Delete User popup */}
                        <SmallPopup
                            title="Delete Plan"
                            smallmodalShow={smallmodalShow}
                            setSmallModalShow={setSmallModalShow}
                            onSubmit={handleConfirmDeleteClick}
                            closeButtonLabel="Cancel"
                            okButtonLabel="Delete"
                        >
                            <div className='row my-3'>
                                <div className="col-md-12 p-0">Are you sure you want to delete plan?</div>
                            </div>

                        </SmallPopup>

                        <div className="card1">

                            <div className="table-header-name">
                                <h5 className="table-text py-3">List</h5>
                                <div className="d-flex flex-wrap justify-content-between align-items-center py-3">
                                    <label className="mx-3">Search</label>
                                    <InputField
                                        type="text"
                                        id="filter-text-box"
                                        placeholder="Search..."
                                        className="w-25"
                                        // onChange={onSearchTextBoxChanged}
                                        onKeyUp={onSearchTextBoxChanged}
                                        // value={searchTxt}
                                        autoComplete="off"
                                    ></InputField>
                                    { (!isAdmin) &&
                                    <ButtonAdd
                                        type="button"
                                        className="btn-add me-0"
                                        onClick={handleAddUserClick}
                                    >
                                        {" "}
                                        <i className="fa-solid fa-circle-plus"></i> Add New Plan
                                    </ButtonAdd>
                                    }

                                </div>
                            </div>

                            <div className="table-wrapper">
                                <div className="table-container">
                                    {planList && (
                                        <AcSimpleTable
                                            key={tableKey}
                                            data={planList}
                                            title=""
                                            pagination={true}
                                            paginationPageSize={limit}
                                            columns={columns}
                                            progressPending={loading}
                                            paginationTotalRows={totalRows}
                                            fixedColumnsStart={admin.FIXED_COLUMNS_START}
                                            getData={getSubscriptionsPlansData}
                                            offset={offset}
                                            limit={limit}
                                            columnName={columnName}
                                            sortDirection={sortDirection}
                                            setLimit={setLimit}
                                            setOffset={setOffset}
                                            setColumnName={setColumnName}
                                            setSortDirection={setSortDirection}
                                            setLoading={setLoading}
                                            paginationPerPage={limit}
                                            paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                                            striped
                                            searchTxt={searchTxt}
                                            sortServer
                                            onSort={handleSort}
                                            defaultSortAsc={false}
                                            setCurrentPage={setCurrentPage}
                                            noData={nodata}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        user_list: state.users.userlist,
        member_list: state.member.memberlist,
        role_list: state.roles.rolelist
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getSubscriptionPlans: (offset, limit, columnName, sortDirection, type, searchTxt) =>
            dispatch(getSubscriptionPlanList(offset, limit, columnName, sortDirection, type, searchTxt)),
        getMembers: (offset, limit, searchTxt) =>
            dispatch(getMemberList(offset, limit, searchTxt)),
        savePlan: (data) => dispatch(createPlan(data)),
        deletePlan: (id) => dispatch(deletePlan(id)),
        getPlan: (id) => dispatch(getPlan(id)),
        updatePlan: (id, data) => dispatch(updatePlan(id, data)),
        getRoles: () => dispatch(roleList()),
        checkPriority: (id, search_txt, type) => dispatch(checkPriority(id, search_txt, type)),
        checkSubscriptionName: (id, search_txt, type) => dispatch(checkSubscriptionName(id, search_txt, type)),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPlans);
